import React from "react";
import "./Footer.css";
import logowhite from "../img/logowhite.png";

function Footer() {
  return (
    <div className="Footer">
      <div className="Footer__top">
        <div className="Footer__top1">
          <a href="/">
            <img src={logowhite} alt="Luxury villa with sea view in Costa Blanca, Spain" />
          </a>
        </div>
        <div className="Footer__top2">
          <div className="Footer__top__title">
            <p>SITE PLAN</p>
          </div>
          <div className="Footer__top__content">
            <a href="/">
              <p>Home</p>
            </a>

            <a href="/properties">
              <p>All Properties</p>
            </a>
            <a href="/ModernProperties">
              <p>Contemporary Properties</p>
            </a>
            <a href="/RusticProperties">
              <p>Rustic Properties</p>
            </a>
            <a href="/ResaleProperties">
              <p>Resale Properties</p>
            </a>
            <a href="/yourrealtor">
              <p>Your Realtor</p>
            </a>
            <a href="/investors">
              <p>Investors</p>
            </a>
            <a href="/about">
              <p>About</p>
            </a>

            <a href="/contact">
              <p>Contact</p>
            </a>
          </div>
        </div>
        <div className="Footer__top3">
          <div className="Footer__top__title">
            <p>LEGAL</p>
          </div>
          <div className="Footer__top__content">
            <a href="/privacy">
              <p>Privacy</p>
            </a>
            <a href="/terms">
              <p>Terms</p>
            </a>
          </div>
        </div>
        <div className="Footer__top4">
          <div className="Footer__top__title">
            <p>CONTACT</p>
          </div>
          <div className="Footer__top__content">
            <p>+1 (346)225-7360</p>
            <p>
              <span>info@luxuryspainproperties.com</span>
            </p>
          </div>
        </div>
      </div>
      <div className="Footer__bottom">
        <p>Copyright © All rights reserved - Luxury Spain Properties 2025</p>
      </div>
    </div>
  );
}

export default Footer;
